<template>
  <!-- 营销资料 -->
  <div class="content">
    <div class="body" :loading="listLoading">
      <div class="search-box">
        <div class="input-item">
          <span class="label">标题名称</span>
          <Input type="text" v-model="searchParams.title" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">上架时间</span>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="searchParams.date"
            @on-change="searchParams.date = $event"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyId" clearable filterable @on-change="companyChange">
            <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">保险产品</span>
          <Select v-model="searchParams.id" clearable filterable>
            <Option v-for="(item, index) in productList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <Tabs v-model="searchParams.columnId" :animated="false" @on-click="searchAjax()">
        <TabPane v-for="bean in columnList" :key="bean.id" :label="bean.name" :name="bean.id" />
      </Tabs>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table ref="selection" :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="title">
            <span class="table-btn" @click="openUrl(row)">{{ row.title }}</span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span v-if="row.type == 1" @click="goDetail(row)" class="table-btn"> 详情 </span>
            <span class="table-btn" @click="download(row)">下载</span>
          </template>
        </Table>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>
    <!-- pdf预览 -->
    <pdf-view ref="pdfView" />
    <!-- 海报预览 -->
    <div class="img-list">
      <img v-for="(bean, i) in previewImg" :key="bean.path" :src="bean.path" preview="img" :id="'img' + i" />
    </div>
  </div>
</template>
<script>
import { pageTool, common } from '@/api/mixins';
import pdfView from '@/components/commons/pdfView';
let vm;
export default {
  mixins: [pageTool, common],
  components: { pdfView },
  data: () => ({
    previewImg: [],
    columns: [
      {
        title: '标题名称',
        slot: 'title',
        minWidth: 200,
        align: 'center'
      },
      {
        title: '所属栏目',
        key: 'columnName',
        minWidth: 100,
        align: 'center'
      },
      {
        title: '文章类型',
        key: 'type',
        width: 100,
        align: 'center',
        render(h, params) {
          const value = params.row.type;
          const map = {
            1: '图文',
            2: '海报',
            3: 'PDF'
          };
          return <div>{map[value] || '-'}</div>;
        }
      },
      {
        title: '上架时间',
        key: 'useTime',
        minWidth: 150,
        align: 'center',
        render(h, params) {
          const value = params.row.useTime ? params.row.useTime.substr(0, 16) : '-';
          return <div>{value}</div>;
        }
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 120,
        fixed: 'right'
      }
    ],
    selectArr: [],
    productList: [],
    columnList: [],
    companyList: []
  }),
  mounted() {
    vm = this;
  },
  async created() {
    vm = this;
    this.queryCompanyList();
    this.queryProductList();
    await this.queryColumn();
    this.initListAjax('/buz/articleBase/read/page');
  },
  methods: {
    // 查询所有栏目
    queryColumn() {
      return this.$http({
        url: '/buz/colum/read/list',
        type: 'POST',
        data: {
          moduleCode: 'MARKET_INFORMATION'
        }
      }).then(res => {
        this.searchParams.columnId = res.data[0].id;
        this.columnList = res.data;
      });
    },
    // 查询所有保司
    queryCompanyList() {
      vm.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        vm.companyList = res.data;
      });
    },
    companyChange() {
      vm.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: vm.searchParams.companyId }
      }).then(res => {
        vm.productList = res.data;
      });
    },
    // 查询所有产品
    queryProductList() {
      vm.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        vm.productList = res.data;
      });
    },
    setListParams(params) {
      params.moduleCode = 'MARKET_INFORMATION';
      params.status = '1';
      if (params.date && params.date[0]) {
        params.useTimeStartTime = params.date[0] + ' 00:00:00';
        params.useTimeEndTime = params.date[1] + ' 23:59:59';
      }
      delete params.date;
      const columnData = this.columnList.find(item => item.id == params.columnId);
      if(columnData && columnData.code == 'PRODUCT_POSTER') {
        params.checkProduct = '1';
      }
    },

    // 选中
    onSelectChange(selectArr) {
      vm.selectArr = selectArr;
    },
    //单击行
    onSelectRow(data, index) {
      vm.$refs.selection.selectAll(false);
      vm.$refs.selection.toggleSelect(index); // 重点 选中勾选
    },

    // 页面切换
    pageChange(index) {
      vm.pageNum = index;
      vm.getList();
    },
    toUrl(url) {
      window.open(url);
    },
    openUrl(row) {
      const base = this.$config.h5Base;
      const url = base + '/apps/articelDetail?id=' + row.id;
      if (row.type == 1) {
        window.open(url);
      } else if (row.type == 2) {
        this.previewImg = row.fileUrlList;
        this.$nextTick(() => {
          this.$previewRefresh();
          window.setTimeout(() => {
            const event = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            document.getElementById('img0').dispatchEvent(event);
          }, 300);
        });
        // window.open(row.url);
      } else if (row.fileUrlList && row.fileUrlList.length) {
        // window.open(row.fileUrlList[0].path);
        this.$refs.pdfView.open(row.fileUrlList);
      }
    },
    // 下载
    download(row) {
      if (!row.fileUrlList || !row.fileUrlList.length) return;
      if (row.fileUrlList.length == 1) {
        this.$units.downloadFun({
          url: '/upload/downloadByUrl',
          params: {
            url: row.fileUrlList[0].path
          }
        });
      } else {
        this.$units.downloadFun({
          url: '/buz/articleBase/downAll',
          params: {
            id: row.id
          }
        });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.content {
  min-width: 1080px;
  min-height: calc(100vh);
  background: #fff;
  .body {
    background: #fff;
    padding: 25px;
    .search-box {
      margin-bottom: 10px;
      .input-item1 {
        width: 33.3%;
        display: inline-block;
        position: relative;
        .label {
          width: 117px;
          position: absolute;
          left: 0;
          top: 0;
          margin: auto;
          line-height: 32px;
          text-align: right;
        }
        .ivu-input-wrapper {
          display: inline-block;
          margin-left: 127px;
          width: calc(100% - 137px);
        }
      }
    }
    .toolbox {
      line-height: 46px;
      background-color: #f8f8f9;
      border-top: 1px solid #e8eaec;
      border-left: 1px solid #e8eaec;
      border-right: 1px solid #e8eaec;
      .add-btn {
        float: right;
        margin-right: 10px;
      }
    }
    .tableBox {
      padding-bottom: 25px;
      background-color: #fff;
      position: relative;
      z-index: 100;
      .bjbtn {
        color: #236dff;
        font-size: 14px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .table-top {
      margin-top: 30px;
    }
  }
}
/deep/ .insuranceModal {
  letter-spacing: 1px;
}
/deep/ .ivu-modal-body {
  padding: 40px 30px 10px 30px;
  .descitem {
    .ivu-form-item-label {
      width: 114px !important;
    }
  }
}
.img-list {
  position: absolute;
  z-index: -1;
  top: -99999px;
}
</style>